import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { SingleImageField } from "@/components/ui/form/fields/image-field/single";

import { useCampaignKeyVisual } from "./use-key-visual/use-key-visual";

type Props = {
	ownerID: string;
	resourceID: string;
};

export const QuestionCampaignKeyVisual = memo(({ ownerID, resourceID }: Props) => {
	const { rawMainKeyVisual, errorMessageMainKV, onSetMainKeyVisual } = useCampaignKeyVisual();

	return (
		<QuestionForMain
			required
			title={"キービジュアル"}
			guide={"推奨画像アスペクト比は16:9です。"}
			inputChildren={
				<div className="space-y-6">
					<SingleImageField
						image={rawMainKeyVisual}
						onInputImage={onSetMainKeyVisual}
						ownerID={ownerID}
						errorMessage={errorMessageMainKV}
						resourceID={resourceID}
					/>
				</div>
			}
		/>
	);
});

QuestionCampaignKeyVisual.displayName = "QuestionCampaignKeyVisual";
